export default __webpack_public_path__ + "./img/cancel.b86a223f5cc7264b41d3ea43dd86920a.png";